import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ config }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleMenuClick = (path, isAnchor = false) => {
    if (isAnchor) {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(path);
          if (element) element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        const element = document.querySelector(path);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuOpen(false);
  };

  const handleHomeClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <header className="header scrolled" style={{
      background: `linear-gradient(to bottom, ${config.design.colors.headerColour} 0%, rgba(239, 231, 226, 0.8) 60%, transparent 100%)`,
      color: config.design.colors.primary,
      boxShadow: 'none',
      borderBottom: 'none'
    }}>
      <nav className="nav container">
        <Link to="/" className="nav-logo" style={{ fontFamily: config.design.fonts.heading, textDecoration: 'none', color: 'inherit' }}>
          {config.couple.name1} & {config.couple.name2}
        </Link>
        <div className="nav-right">
          <ul className="nav-menu">
            <li><Link to="/story" style={{ textDecoration: 'none', color: 'inherit' }}>{config.content.navigation.ourStory}</Link></li>
            <li className="nav-schedule-desktop"><Link to="/schedule" style={{ textDecoration: 'none', color: 'inherit' }}>{config.content.navigation.schedule}</Link></li>
            <li className="nav-events-desktop"><Link to="/schedule" style={{ textDecoration: 'none', color: 'inherit' }}>{config.content.navigation.events}</Link></li>
            <li className="nav-rsvp-desktop"><button onClick={() => handleMenuClick('#rsvp', true)} style={{ textDecoration: 'none', color: 'inherit', background: 'none', border: 'none', fontFamily: 'inherit', fontSize: '0.95rem', cursor: 'pointer', padding: '5px 0', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 300 }}>{config.content.navigation.rsvp}</button></li>
            <li className="nav-explore-desktop"><Link to="/explore-goa" style={{ textDecoration: 'none', color: 'inherit' }}>{config.content.navigation.exploreGoa}</Link></li>
          </ul>
          <button 
            className="hamburger-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{ color: config.design.colors.primary }}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
        <div className={`menu-overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}></div>
        <div className={`dropdown-menu ${menuOpen ? 'open' : ''}`} style={{ backgroundColor: config.design.colors.headerColour, color: config.design.colors.primary }}>
          <ul className="dropdown-menu-list">
            <li>
              <button 
                onClick={handleHomeClick}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit', background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', padding: 0 }}
              >
                {config.content.navigation.home}
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleMenuClick('#story', true)}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit', background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', padding: 0 }}
              >
                {config.content.navigation.ourStory}
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleMenuClick('#schedule', true)}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit', background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', padding: 0 }}
              >
                {config.content.navigation.events}
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleMenuClick('#rsvp', true)}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit', background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', padding: 0 }}
              >
                {config.content.navigation.rsvp}
              </button>
            </li>
            <li>
              <Link 
                to="/how-to-get-here" 
                onClick={() => setMenuOpen(false)}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit' }}
              >
                {config.content.navigation.travelToGoa}
              </Link>
            </li>
            <li>
              <Link 
                to="/explore-goa" 
                onClick={() => setMenuOpen(false)}
                style={{ fontFamily: config.design.fonts.body, textDecoration: 'none', color: 'inherit' }}
              >
                {config.content.navigation.exploreGoa}
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;

